import { Box, Text, VStack } from "@chakra-ui/react";
import { BookmarkSimpleIcon, IconProps } from "@phosphor-icons/react";

interface EmptyStateProps {
  title: string;
  description: string;
  mt?: number;
  icon?: React.ComponentType<IconProps>;
}

const EmptyState = ({
  title,
  description,
  mt = 0,
  icon: Icon = BookmarkSimpleIcon,
}: EmptyStateProps) => {
  return (
    <VStack
      w="full"
      mt={mt}
      borderWidth="1px"
      borderRadius="xl"
      h={{ base: "50vh", md: "60vh", lg: "55vh", "2xl": "63vh" }}
      p={6}
      spacing={3}
      bg="white"
      _dark={{ bg: "gray.800", borderColor: "gray.600" }}
      align="center"
      textAlign="center"
      justifyContent="center"
    >
      <Box color="primary.500">
        <Icon size={42} weight="duotone" />
      </Box>
      <Text fontWeight="semibold" fontSize="lg">
        {title}
      </Text>
      <Text color="gray.500" _dark={{ color: "gray.300" }}>
        {description}
      </Text>
    </VStack>
  );
};

export default EmptyState;
